module.exports = __webpack_public_path__ + "static/desktop/img/step-cn.93d8ee26.jpeg";